import { css } from 'styled-components'

import type { INodeV2StyledProps } from './NodeV2Styled'

const AbsoluteStyled = ({ $style: _s }: INodeV2StyledProps) => css`
  display: block;
`

export default AbsoluteStyled
